import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ReplaySubject } from 'rxjs';

import { CommonModule } from '@angular/common';
import {
    ActionGroup,
    ShActionGroupComponent
} from '../../../../elements/components/action-group/action-group.component';
import { ShActionModeCheckboxComponent } from './components/action-mode-checkbox/action-mode-checkbox.component';
import { SelectionState } from './entities/select-mode.entity';

@Component({
    standalone: true,
    selector: 'sh-context-action-bar',
    templateUrl: './context-action-bar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, ShActionGroupComponent, ShActionModeCheckboxComponent]
})
export class ShContextActionBarComponent {
    public actionGroup$: ReplaySubject<ActionGroup> = new ReplaySubject<ActionGroup>();

    @Input() set actionGroup(actions: ActionGroup) {
        if (actions) {
            this.actionGroup$.next(actions);
        }
    }

    @Input() itemsSelectedLabelKey?: string;
    @Input() noItemsSelectedLabelKey?: string;

    @Input() overlay?: boolean = false;

    @Input() totalPageItemsCount: number;

    @Input() selectedPageItemsCount: number;

    @Input() selectedItemsCount: number;
    @Input() isInitialBulk: boolean;

    @Input() canBatchSelect = false;

    @Output() selectionChanged: EventEmitter<SelectionState> = new EventEmitter<SelectionState>();

    public onSelectionChanged(selectionState: SelectionState): void {
        this.selectionChanged.emit(selectionState);
    }
}
